RA.QueryStringMapper = {

  /**
   * @param {array} paramNames - array of param names that this mapper should manage
   */
  init(paramNames) {
    this.paramNames = paramNames;
    this.encodeMap = {};
    this.decodeMap = {};
  },

  /**
   * @param {string} paramName - The name of the query string parameters
   * @param {string} valueKey - The name of the property key to use when passing in or getting values
   */
  addRenameMapping(paramName, valueKey) {
    this.encodeMap[valueKey] = paramName;
    this.decodeMap[paramName] = valueKey;
  },

  /**
   * @param {object} values - The key/values that should be added to the query string, renaming properties where needed.
   */
  buildQueryString(values = {}) {
    let existingParamMap = RA.Utils.getQueryParams();

    // delete existing params that we own
    this.paramNames.forEach(paramName => delete existingParamMap[paramName]);

    // build new map of params names/values from passed in values map
    let newParamMap = $.extend({}, values);

    // do name re-map
    for (let valueKey in this.encodeMap) {
      let paramName = this.encodeMap[valueKey];
      let val = newParamMap[valueKey];

      if (val != undefined && val !== "") {
        delete newParamMap[valueKey];
        newParamMap[paramName] = val;
      }
    };

    // extend other params with our params
    $.extend(newParamMap, existingParamMap);

    // convert to query string
    return RA.Utils.buildQueryString(newParamMap);
  },

  /**
   * get the key/values for the known param names from the query string, renaming where needed.
   */
  getValues() {
    let params = RA.Utils.getQueryParams();

    let values = {};

    this.paramNames.forEach(paramName => {
      let val = params[paramName];
      let key = paramName;

      if (paramName in this.decodeMap) {
        key = this.decodeMap[paramName];
      }

      if (val != undefined && val !== "") {
        values[key] = val;
      }
    });

    return values;
  }
};